export class ContasPagarBulkRequest {
    public idsParcelas: number[] = [];
    public tipoProcessamentoRecorrencia: number = 1;
}
